var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "custom-payment-wrapper py-5",
      staticStyle: {
        "padding-top": "50px !important",
        "min-height": "100vh",
        width: "100vw",
        "overflow-x": "hidden",
        margin: "0"
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "container bg-white mt-5 shadow rounded-5 overflow-hidden",
          staticStyle: { width: "70% !important" }
        },
        [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 px-0 h-100" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("div", { staticClass: "px-5 pt-4" }, [
                _c("div", { staticClass: "mt-5 p-4" }, [
                  _vm.status == "not_found"
                    ? _c("div", [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "h5",
                          { staticClass: "fw-semibold text-center mb-4" },
                          [_vm._v("Invoice not found.")]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "h5",
                    {
                      staticClass: "fw-semibold text-center text-uppercase mb-4"
                    },
                    [_vm._v("Search Invoice Number")]
                  ),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "job-panel-filter",
                      attrs: { id: "registerform" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.searchForInvoice.apply(null, arguments)
                        },
                        keydown: function($event) {
                          return _vm.invoiceForm.errors.clear(
                            $event.target.name
                          )
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "row g-md-0 g-2" }, [
                        _c("div", { staticClass: "col-md-12 w-100" }, [
                          _c(
                            "div",
                            { staticClass: "w-75 mx-auto" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.invoiceForm.invoice_no,
                                    expression: "invoiceForm.invoice_no"
                                  }
                                ],
                                staticClass:
                                  "form-control border-2 border-success",
                                class: {
                                  "is-invalid": _vm.invoiceForm.errors.has(
                                    "invoice_no"
                                  )
                                },
                                attrs: {
                                  type: "text",
                                  value: "",
                                  placeholder: "Enter Invoice No."
                                },
                                domProps: { value: _vm.invoiceForm.invoice_no },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.invoiceForm,
                                      "invoice_no",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.invoiceForm,
                                  "prop-name": "invoice_no"
                                }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-12 my-4" }, [
                          _c(
                            "div",
                            { staticClass: "h-100 text-center" },
                            [
                              _c(
                                "button-spinner",
                                {
                                  staticClass:
                                    "btn btn-secondary submit-btn px-4 h-100",
                                  staticStyle: {
                                    height: "39px",
                                    color: "#fff"
                                  },
                                  attrs: {
                                    "is-loading": _vm.invoiceForm.isLoading,
                                    disabled: _vm.invoiceForm.isLoading
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa-solid fa-magnifying-glass me-2"
                                  }),
                                  _vm._v(
                                    "Search\n                                            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ]
                  )
                ])
              ])
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex align-items-center ps-5 pt-4" }, [
      _c("div", { staticClass: "text-center" }, [
        _c("div", { staticClass: "pe-4" }, [
          _c("img", {
            staticClass: "soimg",
            attrs: { src: "/../images/logo/logox.png", alt: "" }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ms-5 d-none d-md-block" }, [
        _c("p", { staticClass: "fw-bold" }, [
          _vm._v("Sokoto State Internal Revenue Service")
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "text-muted", staticStyle: { "font-size": "12px" } },
          [
            _vm._v("No. 4 Kano Road, Investment House Sokoto, "),
            _c("br"),
            _vm._v("Sokoto State, Nigeria")
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-5 p-4 text-center" }, [
      _c("img", {
        staticClass: "img-fluid",
        attrs: {
          src: "/../images/Failed.svg",
          alt: "BootstrapBrain Logo",
          width: "100",
          height: "44"
        }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }